// import { HumanizeDurationLanguage, HumanizeDuration } from 'humanize-duration-ts';
import moment from 'moment';

export function dateStringToNumber(dateString: string): number {
  return moment(dateString).valueOf();
}

export function durationToNumber(duration: string): number {
  const isoDuration = moment.duration(duration);

  return isoDuration.asMilliseconds();
}

export function numberToDuration(number: number): string {
  const isoDuration = moment.duration(number, 'millisecond');

  return isoDuration.toISOString();
}

export function numberToHumanDuration(number?: number): string {
  //    return this.getInstance().humanizer.humanize(number || 0);

  const isoDuration = moment.duration(number, 'millisecond');

  return number && number > 0 ? isoDuration.humanize() : 'no duration';
}

export function numberToHumanDate(
  dateNumber?: number,
  format = 'DD/MM/YYYY',
): string {
  const isoDate = moment(dateNumber);

  return isoDate.format(format);
}

export function hoursToMilliseconds(hours: number): number {
  return hours * 60 * 1000;
}

export const stringToColour = (str: string) => {
  let hash = 0;
  str.split('').forEach((char) => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += value.toString(16).padStart(2, '0');
  }
  return colour;
};
